import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const SubmitButton = styled(Button)(() => ({
  borderRadius: 40,
  paddingLeft: 30,
  paddingRight: 30,
  '&:hover': {
    backgroundColor: '#DDE524'
  }
}));

export const PrimaryButton = styled(Button)(() => ({
  borderRadius: 40,
  paddingLeft: 30,
  paddingRight: 30
}));
